module.exports = __webpack_public_path__ + "static/img/animales.c28c24a1.jpg";